// extracted by mini-css-extract-plugin
module.exports = {"headerGrid":"unique-vehicle_headerGrid__B2qmv","gradientBorderBottom":"unique-vehicle_gradientBorderBottom__hubMP","collaspible":"unique-vehicle_collaspible__5nZ9C"};